import { Badge } from "@chakra-ui/react";
import { contractStatusLabels } from "../columns";
import { Contract } from "../types";

const statusColors: Record<Contract["status"], { bg: string; color: string }> =
  {
    preEnrolled: { bg: "#FFF7D6", color: "#E6AE22" },
    enrolled: { bg: "#E3FFE4", color: "#3CB18B" },
    retired: { bg: "#F7F7F7", color: "#9F9DB0" },
  };

type Props = { status: Contract["status"] };

const StatusBadge = ({ status }: Props): JSX.Element => (
  <Badge
    bg={statusColors[status].bg}
    color={statusColors[status].color}
    size="md"
  >
    {contractStatusLabels[status]}
  </Badge>
);

export default StatusBadge;
